import { query_shift_list } from 'liyu-pc-base/api/org-model';

export default () => {
  const search_config: any = {
    model: {
      is_active: true,
      is_me: false,
      page_index: 1,
      page_size: 2000,
    },
    watch: ['aim_org_id'],
  };
  return {
    getData: query_shift_list,
    searchConfig: search_config,
  };
};
